	Object.defineProperty(exports, "__esModule", {
	    value: true
	});exports.default=window.GrimoireJS.lib.math.Vector3;


//////////////////
// WEBPACK FOOTER
// ./~/grimoirejs-math/ref/Vector3.js
// module id = 29
// module chunks = 0